export const MAILCHIMP = {
    userId: "fd9e30f054d2eb89045417926",
    listId: "88d8999242",
    spamTrap: "b_fd9e30f054d2eb89045417926_88d8999242",
    forms: {
        demo: {
            vId: "5047",
            fId: "0090b6e5f0",
            tag: "40197534",
        },
        trial: {
            vId: "5052",
            fId: "0086b6e5f0",
            tag: "40197539",
        },
        newsletter: {
            vId: "5051",
            fId: "0087b6e5f0",
            tag: "40197535",
        },
    },
    actionUrl(form) {
        const { userId, listId, forms } = this;
        const { vId, fId } = forms[form];
        return `https://2xper.us14.list-manage.com/subscribe/post?u=${userId}&amp;id=${listId}&amp;v_id=${vId}&amp;f_id=${fId}`;
    },
};
